import React from 'react';
import { shape, string, bool, node } from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'material-ui/styles';
import { reduceClasses } from '../utils/testUtils';

const styles = theme => ({
  root: {
    boxShadow: '0 20px 40px -20px rgba(0,0,0,.1)',
    backgroundColor: '#FFFFFF',
    borderRadius: '5px',
  },
  clickable: {
    cursor: 'pointer',
    transition: 'box-shadow 375ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    [theme.breakpoints.up('sm')]: {
      '&:hover': {
        boxShadow: '0 14px 56px -20px rgba(0,0,0,.64)',
      },
    },
  },
  scale: {
    transition: 'box-shadow 375ms cubic-bezier(0.4, 0, 0.2, 1) 0ms, transform 375ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    [theme.breakpoints.up('sm')]: {
      '&:hover': {
        transform: 'scale(1.03)',
      },
    },
  },
});

/**
 * General paper with custom elevation.
 */
const Paper = ({ classes: classesProp, className, clickable, children, noScale, test, ...other }) => {
  const classes = test ? reduceClasses(classesProp) : classesProp;

  return (
    <div
      className={classNames({
        [classes.clickable]: clickable,
        [classes.scale]: clickable && !noScale,
      }, classes.root, className)}
      {...other}
    >
      {children}
    </div>
  );
};

Paper.propTypes = {
  /** Classes from the styleSheet generated. */
  classes: shape({}).isRequired,
  /** Useful to extend the styleSheet applied to the root component. */
  className: string,
  /** Adds a hover effect and a pointer cursor. */
  clickable: bool,
  /** The content of the paper. */
  children: node,
  /** Apply only the box-shadow transition. */
  noScale: bool,
  /** Useful for snapshot testing. */
  test: bool,
};

Paper.defaultProps = {
  className: null,
  clickable: false,
  children: null,
  noScale: false,
  test: false,
};

export default withStyles(styles)(Paper);
